export const selectDataSummary = (state) => state.dataSummary.data;
export const selectIsLoading = (state) => state.dataSummary.isLoading;
export const selectError = (state) => state.dataSummary.error;
export const selectPage = (state) => state.dataSummary.page;
export const selectItemPerPage = (state) => state.dataSummary.itemPerPage;
export const selectTotalCount = (state) => state.dataSummary.totalCount;
export const selectFilters = (state) => state.dataSummary.filters;
export const selectIsExporting = (state) => state.dataSummary.isExporting;
